import {
    useGetBodyTypesOptionsQuery,
    useGetBrandsOptionsQuery,
    useGetDisplacementsOptionsQuery,
    useGetDriveTypesOptionsQuery,
    useGetEngineTypesOptionsQuery,
    useGetGenerationsOptionsQuery,
    useGetModelsOptionsQuery,
    useGetSellerTypesOptionsQuery,
    useGetTransmissionOptionsQuery,
    useGetWheelsOptionsQuery
} from "@app/store/filtersOptionsApi";
import { Brand, Generation, Model } from "@app/store/types";
import { useFallbackQuery } from "@shared/lib/hooks/useFallbackQuery";

export const useFilterOptions = (
    brandValue: Brand | undefined,
    modelValue: Model | undefined,
    generationValue: Generation | undefined,
    isExpanded: boolean
) => {
    const { data: brandsOptions, isFetching: brandsOptionsIsFetching } = useGetBrandsOptionsQuery(
        {}
    );

    const { data: modelOptions, isFetching: modelOptionsIsFetching } = useGetModelsOptionsQuery(
        { brandUuid: brandValue?.id || "" },
        { skip: !brandValue?.id }
    );

    const { data: generationsOptions, isFetching: isFetchingGenerations } =
        useGetGenerationsOptionsQuery(
            { model_uuid: modelValue?.id || "" },
            { skip: !modelValue?.id }
        );

    const { data: bodyOptions, isFetching: bodyOptionsIsFetching } = useFallbackQuery(
        useGetBodyTypesOptionsQuery,
        {
            brandUuid: brandValue?.id,
            modelUuid: modelValue?.id,
            generationUuid: generationValue?.id
        },
        { skip: !isExpanded }
    );

    const { data: transmissionOptions, isFetching: transmissionOptionsIsFetch } = useFallbackQuery(
        useGetTransmissionOptionsQuery,
        {
            brandUuid: brandValue?.id,
            modelUuid: modelValue?.id,
            generationUuid: generationValue?.id
        },
        { skip: !isExpanded }
    );

    const { data: engineTypesOptions, isFetching: engineTypesIsFetching } = useFallbackQuery(
        useGetEngineTypesOptionsQuery,
        {
            brandUuid: brandValue?.id,
            modelUuid: modelValue?.id,
            generationUuid: generationValue?.id
        },
        { skip: !isExpanded }
    );

    const { data: driveTypesOptions, isFetching: driveTypesIsFetching } = useFallbackQuery(
        useGetDriveTypesOptionsQuery,
        {
            brandUuid: brandValue?.id,
            modelUuid: modelValue?.id,
            generationUuid: generationValue?.id
        },
        { skip: !isExpanded }
    );

    const { data: displacementsOptions, isFetching: displacementsIsFetching } = useFallbackQuery(
        useGetDisplacementsOptionsQuery,
        {
            brandUuid: brandValue?.id,
            modelUuid: modelValue?.id,
            generationUuid: generationValue?.id
        },
        { skip: !isExpanded }
    );

    const { data: wheelsOptions, isFetching: wheelsIsFetching } = useFallbackQuery(
        useGetWheelsOptionsQuery,
        {
            brandUuid: brandValue?.id,
            modelUuid: modelValue?.id,
            generationUuid: generationValue?.id
        },
        { skip: !isExpanded }
    );

    const { data: sellerTypesOptions, isFetching: sellerTypesIsFetching } =
        useGetSellerTypesOptionsQuery({}, { skip: !isExpanded });

    return {
        brandsOptions,
        brandsOptionsIsFetching,
        modelOptions,
        modelOptionsIsFetching,
        generationsOptions,
        isFetchingGenerations,
        bodyOptions,
        bodyOptionsIsFetching,
        transmissionOptions,
        transmissionOptionsIsFetch,
        engineTypesOptions,
        engineTypesIsFetching,
        driveTypesOptions,
        driveTypesIsFetching,
        displacementsOptions,
        displacementsIsFetching,
        wheelsOptions,
        wheelsIsFetching,
        sellerTypesOptions,
        sellerTypesIsFetching
    };
};